import './mini-bar.css';

interface MiniBarProps {
  /** 0..1 */
  value: number;
  tone?: 'brand' | 'negative' | 'teal';
}

/** Inline progress bar used in dense table rows. */
export function MiniBar({ value, tone = 'brand' }: MiniBarProps) {
  const pct = Math.max(0, Math.min(1, value)) * 100;
  return (
    <div className="mini-bar" role="img" aria-label={`${pct.toFixed(0)}%`}>
      <div className={`mini-bar__fill mini-bar__fill--${tone}`} style={{ width: `${pct}%` }} />
    </div>
  );
}
